import axios from 'axios';

export interface IZmenaEmailuResp {
    code: 'OK' | 'DUPLICITA' | 'AUTENTIZACE';
}

const zmenaEmailuPotvrzeniApi = async (username: string, password: string, auth: string, lang: string) => {
    return axios({
        method: 'POST',
        url: 'Portal/ZmenaEmailu/Potvrzeni',
        data: {
            username,
            password,
            lang
        },
        headers: {
            Authorization: `Bearer ${auth}`
        }
    }).then(resp => resp);
};

export default zmenaEmailuPotvrzeniApi;
